import React from "react"

export const useOutsideClick = (ref, callback) => {
    React.useEffect(() => {
        if(!ref)
            return
            
        /**
         * Called if clicked outside of element
         */
        function handleClickOutside(event) {
            if (ref && ref.current && !ref.current.contains(event.target)) {
                if(callback)
                    callback()
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}